/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Art_BodyInputs */

const en_svc_research_art_body = /** @type {(inputs: Svc_Research_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid-sized, three Baltic depots, hiring dispatchers this quarter. Their site still takes quotes by email only.`)
};

const lv_svc_research_art_body = /** @type {(inputs: Svc_Research_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidēja izmēra, trīs noliktavas Baltijā, šoceturksnī meklē dispečerus. Mājaslapā cenu pieprasījumus joprojām pieņem tikai pa e-pastu.`)
};

/**
* | output |
* | --- |
* | "Mid-sized, three Baltic depots, hiring dispatchers this quarter. Their site still takes quotes by email only." |
*
* @param {Svc_Research_Art_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_art_body = /** @type {((inputs?: Svc_Research_Art_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Art_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_art_body(inputs)
	return en_svc_research_art_body(inputs)
});